define((require) => {
    "use strict";

    var Backbone      = require("backbone"),
        ImprovedModel = require("shared/zbone/ImprovedModel");

    var SalesforceCommerceFiltersModel = ImprovedModel.extend("SalesforceCommerceFiltersModel", {
            defaults: {
                name: true,
                productID: true,
                price: true,
                availability: false,
                brand: true,
                description: false
            }
        }),
        SalesforceCommerceSiteModel = ImprovedModel.extend("SalesforceCommerceSiteModel", {
            embedded: true,

            defaults: {
                siteId: ""
            },

            updateOnSync: function(options) {
                if (options.sync === "save") {
                    return ["id"];
                }
            }
        }),
        SalesforceCommerceSitesCollection = Backbone.Collection.extend("SalesforceCommerceSitesCollection", {
            model: SalesforceCommerceSiteModel,

            deepClone: function() {
                return new SalesforceCommerceSitesCollection(this.toJSON());
            }
        });

    /**
     * Model representing metadata about the SalesforceCommerce settings.
     *
     * @class SalesforceCommerceSettingsModel
     * @constructor
     */
    return ImprovedModel.extend("SalesforceCommerceSettingsModel", {

        /**
         * @type {SalesforceCommerceFiltersModel}
         * Filters are an object that determines whatever the user will be able to see or not in the SalesforceCommerce widget.
         */
        relations: [{
            type:           Backbone.One,
            key:            "filters",
            relatedModel:   SalesforceCommerceFiltersModel
        }, {
            type:           Backbone.Many,
            key:            "sites",
            collectionType: SalesforceCommerceSitesCollection
        }],

        defaults: {

            /**
             * Enables or disables the SalesforceCommerce widget/QuickView.
             *
             * @type {boolean}
             */
            enabled: false,

            /**
             * The absolute address for the SalesforceCommerce API.
             *
             * @example http://salesforcecommerce.zmags.com/dw/shop/v15_1/
             * @type {String}
             */
            webApiUrl: "",

            /**
             * The friendly url provided by the user.
             *
             * @example salesforcecommerce.zmags.com
             * @type {String}
             */
            userUrl: "",

            /**
             * The SalesforceCommerce clientId code.
             *
             * @type {String}
             */
            clientId: "",

            /**
             * All the SalesforceCommerce sites that customers can set up in SalesforceCommerce.
             *
             * @type {String[]}
             */
            sites: [],

            /**
             * The filters of the SalesforceCommerce widget.
             *
             * @type {SalesforceCommerceFiltersModel}
             */
            filters: new SalesforceCommerceFiltersModel()
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/model/SalesforceCommerceSettingsModel.js